export default "__VITE_ASSET__CyyGW_RB__"